import {
  Button,
  Distribute,
  Icon,
  Link,
  Spacer,
  SvgDomain,
  Text,
  TextButton,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CLICKED_SHARE_WITH_TEAM,
  CLICKED_UNDO_SHARE_WITH_TEAM,
} from 'constants/events';
import { moveVideoCreator } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';

import {
  selectUserIsOwner,
  selectVideoBelongsToTeam,
} from 'selectors/shareVideo';
import { selectCurrentUser } from 'selectors/user';

import { TEAM_ACCOUNT_TYPES } from '../../../../../../shared/constants/accountTypes';
import {
  MY_VIDEOS_FOLDER_NAME,
  SPECIAL_FOLDER_ID_MY_VIDEOS,
  SPECIAL_FOLDER_ID_TEAM_VIDEOS,
  TEAM_VIDEOS_FOLDER_NAME,
} from '../../../../../../shared/constants/folders';
import {
  PRIVATE_WORKSPACE,
  TEAM_WORKSPACE,
} from '../../../../../../shared/constants/workspaces';

export default function MoveToTeam() {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const isOwner = useSelector(selectUserIsOwner);
  const isTeamVideo = useSelector(selectVideoBelongsToTeam);

  const isTeamAccount = TEAM_ACCOUNT_TYPES.includes(currentUser.account_type);

  if (!isTeamAccount || !isOwner) {
    return null;
  }

  function moveVideoToTeam() {
    analytics.track(CLICKED_SHARE_WITH_TEAM);
    dispatch(
      moveVideoCreator(
        SPECIAL_FOLDER_ID_TEAM_VIDEOS,
        TEAM_VIDEOS_FOLDER_NAME,
        false,
        TEAM_WORKSPACE
      )
    );
  }

  function moveVideoToPersonal() {
    analytics.track(CLICKED_UNDO_SHARE_WITH_TEAM);
    dispatch(
      moveVideoCreator(
        SPECIAL_FOLDER_ID_MY_VIDEOS,
        MY_VIDEOS_FOLDER_NAME,
        false,
        PRIVATE_WORKSPACE
      )
    );
  }

  return (
    <div>
      <Text size="large">Share with your team</Text>
      <Spacer top={1}></Spacer>
      <Text size="small">
        Allow teammates to easily find and collaborate on this video.
      </Text>
      <Spacer top={2}></Spacer>
      {isTeamVideo && (
        <Distribute isSpread alignment="center">
          <Distribute gap={1} alignment="center">
            <Icon icon={<SvgDomain />} />
            <Text>
              Moved to{' '}
              <Link variant="neutral" href="/team-videos">
                Team Library
              </Link>
              !
            </Text>
          </Distribute>
          <TextButton onClick={moveVideoToPersonal}>Undo</TextButton>
        </Distribute>
      )}
      {!isTeamVideo && (
        <Button
          variant="neutral"
          hasFullWidth
          icon={<SvgDomain />}
          onClick={moveVideoToTeam}
        >
          Move to Team Library
        </Button>
      )}
    </div>
  );
}
